import { render, staticRenderFns } from "./TextShade.vue?vue&type=template&id=4d41f8ec&scoped=true&"
import script from "./TextShade.vue?vue&type=script&lang=js&"
export * from "./TextShade.vue?vue&type=script&lang=js&"
import style0 from "./TextShade.vue?vue&type=style&index=0&id=4d41f8ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d41f8ec",
  null
  
)

export default component.exports